import React, { useEffect, useState } from "react";
import DatePicker from "react-multi-date-picker";
import axios from "axios";
import { apiKey } from "../config/config";
import Table from "../components/Table";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function SellItemReport({ lang }) {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;

  const branchId = JSON.parse(
    JSON.parse(sessionStorage.getItem("aman-admin")).admin
  ).id;

  const [reports, setReports] = useState([]);
  const [investorList, setInvestorList] = useState([]);

  const [filter, setFilter] = useState(""); // all time by default
  const [investor, setInvestor] = useState("");
  const [from, setFrom] = useState(null);
  const [to, setTo] = useState(null);

  // const [sortOrder, setSortOrder] = useState("desc");

  const formatYMD = (d) => {
    if (!d) return "";
    const dt = new Date(d);
    if (Number.isNaN(dt.getTime())) return "";
    return dt.toISOString().split("T")[0];
  };

  function convertDateFormat(inputDate) {
    if (!inputDate) return "";
    const dateObject = new Date(inputDate);
    if (Number.isNaN(dateObject.getTime())) return "";
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    return dateObject.toLocaleDateString("en-GB", options);
  }

  const columns = [
    { header: "SN", cell: (row) => row.row.index + 1 },
    { header: lang.Item || "Item", accessorKey: "inventory_item" },
    { header: lang.Investor || "Investor", accessorKey: "investor_name" },
    { header: lang.Selling_Price || "Selling Price", accessorKey: "sell_price" },
    { header: lang.Quantity || "Quantity", accessorKey: "quantity" },
    {
      header: lang.date || "Date",
      accessorKey: "created_at",
      cell: (row) => convertDateFormat(row.row.original.created_at),
    },
    // {
    //   header: lang.Actions || "Actions",
    //   cell: () => <span className="px-3 py-2 badge bg-success">Sold</span>,
    // },
  ];

  // ✅ investors dropdown
  useEffect(() => {
    axios
      .get(apiKey + "/investor", {
        params: { branch_id: branchId },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setInvestorList(res.data.result || []))
      .catch((err) => {
        console.error(err);
        toast.error("Error loading investors");
      });
  }, [branchId, token]);

  // ✅ reset from/to if not from_to
  useEffect(() => {
    if (filter !== "from_to") {
      setFrom(null);
      setTo(null);
    }
  }, [filter]);

  // ✅ fetch reports (SERVER SIDE FILTERING)
  useEffect(() => {
    if (!branchId) return;

    axios
      .get(apiKey + "/sell-item-reports", {
        params: {
          branch_id: branchId,
          filter,
          investor_id: investor || "",
          from: filter === "from_to" ? formatYMD(from) : "",
          to: filter === "from_to" ? formatYMD(to) : "",
          // sort: sortOrder,
        },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setReports(res.data.result || []);
      })
      .catch((err) => {
        console.error(err);
        toast.error("Error loading sell item report");
      });
  }, [branchId, filter, investor, from, to, token]);

  return (
    <main className="main" id="main">
      <ToastContainer position="bottom-right" autoClose={5000} theme="colored" />

      <div className="pagetitle">
        <h1>{lang.Reports || "Reports"}</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24">
                <path d="m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"></path>
              </svg>
            </li>
            <li className="breadcrumb-item">{lang.Reports || "Reports"}</li>
            <li className="breadcrumb-item active">
              {lang.Sell_Item_Report || "Sell Item Report"}
            </li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className="mt-3 mb-3">
                  <div className="rr">{lang.Sell_Item_Report || "Sell Item Report"}</div>

                  <div className="row justify-content-end gap-2">
                    {filter === "from_to" && (
                      <>
                        <div className="custom-datepicker">
                          <DatePicker
                            placeholder={lang.From || "From"}
                            style={{ left: "35%", top: "5px", height: "auto" }}
                            containerStyle={{ height: "auto" }}
                            onChange={(e) => setFrom(new Date(e))}
                          />
                        </div>

                        <div className="custom-datepicker">
                          <DatePicker
                            placeholder={lang.To || "To"}
                            style={{ left: "45%", top: "5px", height: "auto" }}
                            containerStyle={{ height: "auto" }}
                            onChange={(e) => setTo(new Date(e))}
                          />
                        </div>
                      </>
                    )}

                    <select
                      onChange={(e) => setFilter(e.target.value)}
                      className="btn-export me-0 mb-4 mb-md-0 col-3"
                      value={filter}
                    >
                      <option value="">{lang.All_Time || "All Time"}</option>
                      <option value="today">{lang.Today || "Today"}</option>
                      <option value="this_week">{lang.This_Week || "This Week"}</option>
                      <option value="this_month">{lang.This_Month || "This Month"}</option>
                      <option value="this_year">{lang.This_Year || "This Year"}</option>
                      <option value="from_to">{lang["From To"] || "From To"}</option>
                    </select>

                    <select
                      onChange={(e) => setInvestor(e.target.value)}
                      className="btn-export col-3"
                      value={investor}
                    >
                      <option value="">{lang.all_investors || "All Investors"}</option>
                      {investorList.map((inv, index) => (
                        <option key={index} value={inv.id}>
                          {inv.FullName}
                        </option>
                      ))}
                    </select>

                    {/* <select
                      onChange={(e) => setSortOrder(e.target.value)}
                      className="btn-export col-3"
                      value={sortOrder}
                    >
                      <option value="desc">{lang.Newest_First || "Newest First"}</option>
                      <option value="asc">{lang.Oldest_First || "Oldest First"}</option>
                    </select> */}
                  </div>
                </div>

                <div classNames="d-flex mt-3 mb-3">
                  <Table lang={lang} data={reports} columns={columns} exportOption={true} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
